import request from "@/utils/request";

export interface AffiliatedOrganizationItem {
	/**
	 * 管理员ID集合，例如：[1001,1002]
	 */
	admin_ids: number[];
	/**
	 * 管理员名称集合，例如：["张三","李四"]
	 */
	admin_names: string[];
	/**
	 * 管理员
	 */
	creator?: string;
	/**
	 * id
	 */
	id: number;
	/**
	 * 行业名称
	 */
	industry_name?: string;
	/**
	 * 下级企业id
	 */
	next_association_id: number;
	/**
	 * 下级企业名称
	 */
	next_company_name: string;
	/**
	 * 当前企业id
	 */
	parent_association_id: number;
	/**
	 * 当前企业名称
	 */
	parent_company_name: string;
	/**
	 * 成员数量
	 */
	persons_num: number;
	/**
	 * 拒绝备注
	 */
	refuse_remark?: string;
	/**
	 * 申请备注
	 */
	remark: string;
	/**
	 * 审核状态：0-待审核；1-审核通过；2-审核拒绝
	 */
	status: number;
}

export interface fetchAffiliatedOrganizationsRequest {
	/**
	 * 审核状态：0-待审核；1-通过；2-拒绝
	 */
	status?: number;
}

export const fetchAffiliatedOrganizations = (data: fetchAffiliatedOrganizationsRequest) =>
	request.post<AffiliatedOrganizationItem[]>("/association/list", data);

export interface RelatedAffiliatedOrganizationRequest {
	/**
	 * 管理员ID集合，例如：[1001,1002]
	 */
	admin_ids?: number[];
	/**
	 * 上级部门ID
	 */
	dept_id?: number;
	/**
	 * 被关联的企业ID
	 */
	next_association_id: number;
	/**
	 * 申请备注说明
	 */
	remark?: string;
}

export const relatedAffiliatedOrganization = (data: RelatedAffiliatedOrganizationRequest) =>
	request.post("/association/related", data);

export interface SearchCompanyListItemChild {
	children?: SearchCompanyListItemChild[];
	/**
	 * 行业二级id
	 */
	id: number;
	/**
	 * 行业名称
	 */
	name: string;
	/**
	 * 行业父级id
	 */
	pid: number;
}

export interface SearchCompanyListItem {
	/**
	 * 行业二级信息
	 */
	children: SearchCompanyListItemChild[];
	/**
	 * 行业一级id
	 */
	id: number;
	/**
	 * 行业名称
	 */
	name: string;
	/**
	 * 行业父级id
	 */
	pid: number;
}

export const fetchSearchCompanyList = (name: string) =>
	request.post<SearchCompanyListItem[]>("/common/searchCompany", {
		name,
	});

export const cancelAffiliatedOrganization = (id: number) =>
	request.post("/association/del", {
		id,
	});

export const unlinkAffiliatedOrganization = (id: number) =>
	request.post("/association/unlink", {
		id,
	});

export interface EditAffiliatedOrganizationAdminRequest {
	/**
	 * 成员员ID集合，例如：[1001,1002]
	 */
	admin_ids: number[];
	/**
	 * 关联ID
	 */
	id: number;
	/**
	 * 申请备注说明
	 */
	remark?: string;
}

export const editAffiliatedOrganizationAdmin = (data: EditAffiliatedOrganizationAdminRequest) =>
	request.post("/association/edit", data);

export interface AssociationApprovalListItem {
	/**
	 * 管理员
	 */
	creator?: string;
	/**
	 * id
	 */
	id: number;
	/**
	 * 行业名称
	 */
	industry_name?: string;
	/**
	 * 下级企业id
	 */
	next_association_id?: number;
	/**
	 * 下级企业名称
	 */
	next_company_name?: string;
	/**
	 * 当前企业id
	 */
	parent_association_id: number;
	/**
	 * 当前企业名称
	 */
	parent_company_name: string;
	/**
	 * 成员数量
	 */
	persons_num?: number;
	/**
	 * 拒绝备注
	 */
	refuse_remark?: string;
	/**
	 * 申请备注
	 */
	remark?: string;
	/**
	 * 审核状态：0-待审核；1-审核通过；2-审核拒绝
	 */
	status?: number;
}

export interface FetchAssociationApprovalListRequest {
	/**
	 * 审核状态：0-待审核；1-通过；2-拒绝
	 */
	status?: number;
}

export const fetchAssociationApprovalList = (data: FetchAssociationApprovalListRequest) =>
	request.post<AssociationApprovalListItem[]>("/association/approvalList", data);

export interface ApprovalAffiliatedOrganizationRequest {
	/**
	 * 关联id
	 */
	id: number;
	/**
	 * 拒绝申请备注说明
	 */
	refuse_remark?: string;
	/**
	 * 审核状态：1-通过；2-拒绝
	 */
	status: number;
}

export const approvalAffiliatedOrganization = (data: ApprovalAffiliatedOrganizationRequest) =>
	request.post("/association/approval", data);
